import { MediaDisplay } from "@package/ui-wall-components";
import { get } from "lodash";
import { useMemo } from "react";
import { type FlyoutProps } from "../../utils/flyout-props";
import { WipeAwayForeground } from "./WipeAwayForeground/WipeAwayForeground";

export function FlyoutWipeAway({ screen }: FlyoutProps) {
  const mediaForeground = useMemo<string | undefined>(
    () =>
      get(
        screen.flyout?.post,
        "customData.flyout.fullScreenMedia.mediaForeground",
      ) ?? undefined,
    [screen.flyout?.post],
  );
  const mediaBackground = useMemo<string | undefined>(
    () =>
      get(
        screen.flyout?.post,
        "customData.flyout.fullScreenMedia.mediaBackground",
      ) ?? undefined,
    [screen.flyout?.post],
  );
  const brushRadius = useMemo<number>(
    () =>
      get(
        screen.flyout?.post,
        "customData.flyout.fullScreenMedia.brushRadius",
      ) ?? 15,
    [screen.flyout?.post],
  );

  return (
    <div className="relative h-full w-full">
      <div className="absolute top-0 left-0 w-full h-full">
        <MediaDisplay id={mediaBackground} />
      </div>
      <div className="absolute top-0 left-0 w-full h-full">
        <WipeAwayForeground
          media={mediaForeground}
          brushRadiusMultipler={brushRadius}
        />
      </div>
    </div>
  );
}
